module.exports = __webpack_public_path__ + "static/img/label-icon.2df7b9b7.png";